/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Master Data Hub
 * OpenAPI spec version: 0.1.0
 */
import axios from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface AcceptResponse {
  code?: string;
  message: string;
}

export interface OperationValueAdd {
  [key: string]: unknown;
}

/**
 * An AddOperation represents adding a row to a multivalue.
 *
 * The list of values can contain multiple schema_id, value pairs,
 * for adding multiple columns of the multivalue row at once.
 */
export interface AddOperation {
  id: number;
  op?: 'add';
  value: OperationValueAdd[];
  [key: string]: unknown;
}

export type AggregateAggregateItem = { [key: string]: unknown };

export type AggregateCollation = { [key: string]: unknown } | null;

export type AggregateLet = { [key: string]: unknown } | null;

export type AggregateOptions = { [key: string]: unknown } | null;

export interface Aggregate {
  /**
   * MongoDB aggregate command is used in the background.
   *
   * The query runtime is limited to 120 seconds.
   *
   * [MongoDB aggregate documentation]
   * (https://www.mongodb.com/docs/manual/reference/method/db.collection.aggregate/)
   *
   * If there is no $limit stage specified after a $search stage, the default limit of 50
   * will be used.
   * @minItems 1
   */
  aggregate: AggregateAggregateItem[];
  collation?: AggregateCollation;
  let?: AggregateLet;
  options?: AggregateOptions;
}

export type AggregateBodyAggregateItem = { [key: string]: unknown };

export type AggregateBodyCollation = { [key: string]: unknown } | null;

export type AggregateBodyLet = { [key: string]: unknown } | null;

export type AggregateBodyOptions = { [key: string]: unknown } | null;

export interface AggregateBody {
  /**
   * MongoDB aggregate command is used in the background.
   *
   * The query runtime is limited to 120 seconds.
   *
   * [MongoDB aggregate documentation]
   * (https://www.mongodb.com/docs/manual/reference/method/db.collection.aggregate/)
   *
   * If there is no $limit stage specified after a $search stage, the default limit of 50
   * will be used.
   * @minItems 1
   */
  aggregate: AggregateBodyAggregateItem[];
  collation?: AggregateBodyCollation;
  let?: AggregateBodyLet;
  options?: AggregateBodyOptions;
  dataset: string;
}

export interface Tokenizer {
  type: string;
  [key: string]: unknown;
}

export interface TokenFilter {
  type: string;
  [key: string]: unknown;
}

export interface CharFilter {
  type: string;
  [key: string]: unknown;
}

export interface AnalyzerInput {
  /** @minLength 1 */
  name: string;
  tokenizer: Tokenizer;
  tokenFilters?: TokenFilter[] | null;
  charFilters?: CharFilter[] | null;
}

export interface AnalyzerOutput {
  /** @minLength 1 */
  name: string;
  tokenizer: Tokenizer;
  token_filters?: TokenFilter[] | null;
  char_filters?: CharFilter[] | null;
}

export type AnnotationContentAction = typeof AnnotationContentAction[keyof typeof AnnotationContentAction];

export const AnnotationContentAction = {
  initialize: 'initialize',
  user_update: 'user_update',
  export: 'export',
  started: 'started',
  confirm: 'confirm',
  updated: 'updated',
} as const;

export type MessageType = typeof MessageType[keyof typeof MessageType];

export const MessageType = {
  error: 'error',
  warning: 'warning',
  info: 'info',
} as const;

/**
 * Message to be displayed in the Rossum UI.
 */
export interface ResponseMessage {
  type: MessageType;
  content: string;
  id?: number | null;
}

export interface OperationValue {
  [key: string]: unknown;
}

export interface ReplaceOperation {
  id: number;
  op?: 'replace';
  value: OperationValue;
  [key: string]: unknown;
}

export interface RemoveOperation {
  id: number;
  op?: 'remove';
  [key: string]: unknown;
}

export interface ResponseAutomationBlocker {
  id?: number | null;
  content: string;
}

/**
 * Payload Rossum is expecting as a response to 'annotation_content' event trigger.
 */
export interface AnnotationContentHookResponse {
  messages?: ResponseMessage[];
  operations?: (AddOperation | ReplaceOperation | RemoveOperation)[];
  automation_blockers?: ResponseAutomationBlocker[];
}

export type AnnotationLifecycleStatus = typeof AnnotationLifecycleStatus[keyof typeof AnnotationLifecycleStatus];

export const AnnotationLifecycleStatus = {
  created: 'created',
  importing: 'importing',
  failed_import: 'failed_import',
  split: 'split',
  to_review: 'to_review',
  reviewing: 'reviewing',
  in_workflow: 'in_workflow',
  confirmed: 'confirmed',
  rejected: 'rejected',
  exporting: 'exporting',
  exported: 'exported',
  failed_export: 'failed_export',
  postponed: 'postponed',
  deleted: 'deleted',
  purged: 'purged',
} as const;

export interface DatapointContent {
  value: string;
  normalized_value?: string | null;
  [key: string]: unknown;
}

export interface EnumOption {
  value: string;
  label: string;
  [key: string]: unknown;
}

export interface ContentDatapointElement {
  id: number;
  url: string;
  schema_id: string;
  category: 'datapoint';
  content?: DatapointContent | null;
  validation_sources: string[];
  options?: EnumOption[] | null;
  [key: string]: unknown;
}

export interface ContentTupleElement {
  id: number;
  url: string;
  schema_id: string;
  category: 'tuple';
  children: ContentDatapointElement[];
  [key: string]: unknown;
}

export interface ContentMultivalueElement {
  id: number;
  url: string;
  schema_id: string;
  category: 'multivalue';
  children: ContentTupleElement[] | ContentDatapointElement[];
  [key: string]: unknown;
}

export interface ContentSectionElement {
  id: number;
  url: string;
  schema_id: string;
  category: 'section';
  children: (ContentMultivalueElement | ContentDatapointElement)[];
  [key: string]: unknown;
}

export interface AnnotationWithContent {
  id: number;
  schema: string;
  document: string;
  email?: string | null;
  messages?: ResponseMessage[] | null;
  organization: string;
  pages?: string[];
  previous_status?: AnnotationLifecycleStatus | null;
  queue: string;
  relations?: string[];
  status: AnnotationLifecycleStatus;
  url: string;
  training_enabled?: boolean;
  einvoice?: boolean;
  content: ContentSectionElement[];
  [key: string]: unknown;
}

export type AutocompleteFieldMappingInputTokenization =
  | typeof AutocompleteFieldMappingInputTokenization[keyof typeof AutocompleteFieldMappingInputTokenization]
  | null;

export const AutocompleteFieldMappingInputTokenization = {
  edge_gram: 'edge_gram',
  right_edge_gram: 'right_edge_gram',
  n_gram: 'n_gram',
} as const;

/**
 * Typeahead-style indexing (the engine's ``autocomplete`` type).
 *
 * The analyzer runs before gram generation, so it defines what a token is:
 * ``lucene.keyword`` gives whole-value prefix search (codes, IDs), the default
 * ``lucene.standard`` gives per-word typeahead.
 */
export interface AutocompleteFieldMappingInput {
  type: 'autocomplete';
  analyzer?: string | null;
  tokenization?: AutocompleteFieldMappingInputTokenization;
  minGrams?: number | null;
  maxGrams?: number | null;
  foldDiacritics?: boolean | null;
}

export type AutocompleteFieldMappingOutputTokenization =
  | typeof AutocompleteFieldMappingOutputTokenization[keyof typeof AutocompleteFieldMappingOutputTokenization]
  | null;

export const AutocompleteFieldMappingOutputTokenization = {
  edge_gram: 'edge_gram',
  right_edge_gram: 'right_edge_gram',
  n_gram: 'n_gram',
} as const;

/**
 * Typeahead-style indexing (the engine's ``autocomplete`` type).
 *
 * The analyzer runs before gram generation, so it defines what a token is:
 * ``lucene.keyword`` gives whole-value prefix search (codes, IDs), the default
 * ``lucene.standard`` gives per-word typeahead.
 */
export interface AutocompleteFieldMappingOutput {
  type: 'autocomplete';
  analyzer?: string | null;
  tokenization?: AutocompleteFieldMappingOutputTokenization;
  min_grams?: number | null;
  max_grams?: number | null;
  fold_diacritics?: boolean | null;
}

export interface BodyCreateDatasetApiV1DatasetDatasetNamePost {
  /**
   * The following file formats are supported:
   * - JSON - Must be a list of objects like `[{...}, {...}, ...]`.
   * - CSV - The dialect of the csv file is automatically determined. If the header is
   * missing, an alphabetical keys are generated for the columns. If you run into problems,
   * consider turning off the dynamic mode.
   * - XML - XML attributes are ignored, namespaces are removed from the key names.
   * The dataset entities must be nested one level at maximum.
   *     - Examples of valid XML structures:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <invoice>
   *     <id>...</id>
   *     <name>...</name>
   * </invoice>
   * ```
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <invoices>
   *     <invoice>
   *           <id>...</id>
   *           <name>...</name>
   *     </invoice>
   *     <invoice>
   *           <id>...</id>
   *           <name>...</name>
   *     </invoice>
   * </invoices>
   * ```
   * - XLSX - Only the active spreadsheet is used.
   * Headers are treated the same way as in a CSV file.
   */
  file: Blob;
  /**
   * All [major encodings](https://docs.python.org/3.12/library/codecs.html#standard-encodings)
   * are supported. If you are not sure, your file probably uses a UTF-8 encoding.
   */
  encoding: string;
  /**
   * With dynamic mode off, the following file formats are expected:
   * - CSV - The first row is always used as headers.
   * The column delimiter must be a semicolon `;`.
   * - XML - Elements with the same name on the same level anywhere in the
   * XML tree are treated as the entities.
   *     - Example of valid XML structure:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <root>
   *     <invoices>
   *           <invoice>
   *             <id>...</id>
   *             <name>...</name>
   *           </invoice>
   *           <invoice>
   *             <id>...</id>
   *             <name>...</name>
   *           </invoice>
   *     </invoices>
   * </root>
   * ```
   * - XLSX - The first row is always used as headers.
   */
  dynamic?: boolean;
  /** (CSV only) The character used to separate fields (columns) in the CSV, default `;`. */
  field_delimiter?: string | null;
  /** (CSV only) The character used to escape special characters, none is set by default. */
  escape_character?: string | null;
  /** (CSV only) The character used to quote fields containing special characters, default `"`. */
  quote_character?: string | null;
  /** (CSV only) If true, we are expecting the quote character to be escaped by doubling it. */
  double_quote?: boolean | null;
  /**
   * (CSV, XLSX only) Array of field names. Can be used to set field names
   * if they are missing in the file, but also to rewrite existing ones.
   * To rewrite existing ones, ignore_first_line must be set to true.
   *
   * Must be a `multipart/form-data` valid array - either multiple fields of
   * the given name, or a single field with comma (`,`) separated values.
   */
  field_names?: string[];
  /**
   * (CSV, XLSX only) Ignore first line in the file, false by default.
   * Can be used to replace header by a custom one (see `field_names`).
   * If header is not present, it will remove first data row!
   */
  ignore_first_line?: boolean | null;
}

export interface BodyReplaceDatasetApiV1DatasetDatasetNamePut {
  /**
   * The following file formats are supported:
   * - JSON - Must be a list of objects like `[{...}, {...}, ...]`.
   * - CSV - The dialect of the csv file is automatically determined. If the header is
   * missing, an alphabetical keys are generated for the columns. If you run into problems,
   * consider turning off the dynamic mode.
   * - XML - XML attributes are ignored, namespaces are removed from the key names.
   * The dataset entities must be nested one level at maximum.
   *     - Examples of valid XML structures:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <invoice>
   *     <id>...</id>
   *     <name>...</name>
   * </invoice>
   * ```
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <invoices>
   *     <invoice>
   *           <id>...</id>
   *           <name>...</name>
   *     </invoice>
   *     <invoice>
   *           <id>...</id>
   *           <name>...</name>
   *     </invoice>
   * </invoices>
   * ```
   * - XLSX - Only the active spreadsheet is used.
   * Headers are treated the same way as in a CSV file.
   */
  file: Blob;
  /**
   * All [major encodings](https://docs.python.org/3.12/library/codecs.html#standard-encodings)
   * are supported. If you are not sure, your file probably uses a UTF-8 encoding.
   */
  encoding: string;
  /**
   * With dynamic mode off, the following file formats are expected:
   * - CSV - The first row is always used as headers.
   * The column delimiter must be a semicolon `;`.
   * - XML - Elements with the same name on the same level anywhere in the
   * XML tree are treated as the entities.
   *     - Example of valid XML structure:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <root>
   *     <invoices>
   *           <invoice>
   *             <id>...</id>
   *             <name>...</name>
   *           </invoice>
   *           <invoice>
   *             <id>...</id>
   *             <name>...</name>
   *           </invoice>
   *     </invoices>
   * </root>
   * ```
   * - XLSX - The first row is always used as headers.
   */
  dynamic?: boolean;
  /** (CSV only) The character used to separate fields (columns) in the CSV, default `;`. */
  field_delimiter?: string | null;
  /** (CSV only) The character used to escape special characters, none is set by default. */
  escape_character?: string | null;
  /** (CSV only) The character used to quote fields containing special characters, default `"`. */
  quote_character?: string | null;
  /** (CSV only) If true, we are expecting the quote character to be escaped by doubling it. */
  double_quote?: boolean | null;
  /**
   * (CSV, XLSX only) Array of field names. Can be used to set field names
   * if they are missing in the file, but also to rewrite existing ones.
   * To rewrite existing ones, ignore_first_line must be set to true.
   *
   * Must be a `multipart/form-data` valid array - either multiple fields of
   * the given name, or a single field with comma (`,`) separated values.
   */
  field_names?: string[];
  /**
   * (CSV, XLSX only) Ignore first line in the file, false by default.
   * Can be used to replace header by a custom one (see `field_names`).
   * If header is not present, it will remove first data row!
   */
  ignore_first_line?: boolean | null;
  /**
   * The switch enables calling this endpoint with a non-existing
   * dataset name, resulting in dataset creation as if the POST method was used.
   */
  replace_or_new?: boolean;
}

export interface BodyReplaceDatasetApiV2DatasetsDatasetNameDataPut {
  /**
   * The following file formats are supported:
   * - JSON - Must be a list of objects like `[{...}, {...}, ...]`.
   * - CSV - The dialect of the csv file is automatically determined. If the header is
   * missing, an alphabetical keys are generated for the columns. If you run into problems,
   * consider turning off the dynamic mode.
   * - XML - XML attributes are ignored, namespaces are removed from the key names.
   * The dataset entities must be nested one level at maximum.
   *     - Examples of valid XML structures:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <invoice>
   *     <id>...</id>
   *     <name>...</name>
   * </invoice>
   * ```
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <invoices>
   *     <invoice>
   *           <id>...</id>
   *           <name>...</name>
   *     </invoice>
   *     <invoice>
   *           <id>...</id>
   *           <name>...</name>
   *     </invoice>
   * </invoices>
   * ```
   * - XLSX - Only the active spreadsheet is used.
   * Headers are treated the same way as in a CSV file.
   */
  file: Blob;
  /**
   * All [major encodings](https://docs.python.org/3.12/library/codecs.html#standard-encodings)
   * are supported. If you are not sure, your file probably uses a UTF-8 encoding.
   */
  encoding: string;
  /**
   * With dynamic mode off, the following file formats are expected:
   * - CSV - The first row is always used as headers.
   * The column delimiter must be a semicolon `;`.
   * - XML - Elements with the same name on the same level anywhere in the
   * XML tree are treated as the entities.
   *     - Example of valid XML structure:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <root>
   *     <invoices>
   *           <invoice>
   *             <id>...</id>
   *             <name>...</name>
   *           </invoice>
   *           <invoice>
   *             <id>...</id>
   *             <name>...</name>
   *           </invoice>
   *     </invoices>
   * </root>
   * ```
   * - XLSX - The first row is always used as headers.
   */
  dynamic?: boolean;
  /** (CSV only) The character used to separate fields (columns) in the CSV, default `;`. */
  field_delimiter?: string | null;
  /** (CSV only) The character used to escape special characters, none is set by default. */
  escape_character?: string | null;
  /** (CSV only) The character used to quote fields containing special characters, default `"`. */
  quote_character?: string | null;
  /** (CSV only) If true, we are expecting the quote character to be escaped by doubling it. */
  double_quote?: boolean | null;
  /**
   * (CSV, XLSX only) Array of field names. Can be used to set field names
   * if they are missing in the file, but also to rewrite existing ones.
   * To rewrite existing ones, ignore_first_line must be set to true.
   *
   * Must be a `multipart/form-data` valid array - either multiple fields of
   * the given name, or a single field with comma (`,`) separated values.
   */
  field_names?: string[];
  /**
   * (CSV, XLSX only) Ignore first line in the file, false by default.
   * Can be used to replace header by a custom one (see `field_names`).
   * If header is not present, it will remove first data row!
   */
  ignore_first_line?: boolean | null;
}

export interface BodyUpdateDatasetApiV1DatasetDatasetNamePatch {
  /**
   * The following file formats are supported:
   * - JSON - Must be a list of objects like `[{...}, {...}, ...]`.
   * - CSV - The dialect of the csv file is automatically determined. If the header is
   * missing, an alphabetical keys are generated for the columns. If you run into problems,
   * consider turning off the dynamic mode.
   * - XML - XML attributes are ignored, namespaces are removed from the key names.
   * The dataset entities must be nested one level at maximum.
   *     - Examples of valid XML structures:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <invoice>
   *     <id>...</id>
   *     <name>...</name>
   * </invoice>
   * ```
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <invoices>
   *     <invoice>
   *           <id>...</id>
   *           <name>...</name>
   *     </invoice>
   *     <invoice>
   *           <id>...</id>
   *           <name>...</name>
   *     </invoice>
   * </invoices>
   * ```
   * - XLSX - Only the active spreadsheet is used.
   * Headers are treated the same way as in a CSV file.
   */
  file: Blob;
  /**
   * All [major encodings](https://docs.python.org/3.12/library/codecs.html#standard-encodings)
   * are supported. If you are not sure, your file probably uses a UTF-8 encoding.
   */
  encoding: string;
  /**
   * With dynamic mode off, the following file formats are expected:
   * - CSV - The first row is always used as headers.
   * The column delimiter must be a semicolon `;`.
   * - XML - Elements with the same name on the same level anywhere in the
   * XML tree are treated as the entities.
   *     - Example of valid XML structure:
   * ```xml
   * <?xml version="1.0" encoding="UTF-8"?>
   * <root>
   *     <invoices>
   *           <invoice>
   *             <id>...</id>
   *             <name>...</name>
   *           </invoice>
   *           <invoice>
   *             <id>...</id>
   *             <name>...</name>
   *           </invoice>
   *     </invoices>
   * </root>
   * ```
   * - XLSX - The first row is always used as headers.
   */
  dynamic?: boolean;
  /** (CSV only) The character used to separate fields (columns) in the CSV, default `;`. */
  field_delimiter?: string | null;
  /** (CSV only) The character used to escape special characters, none is set by default. */
  escape_character?: string | null;
  /** (CSV only) The character used to quote fields containing special characters, default `"`. */
  quote_character?: string | null;
  /** (CSV only) If true, we are expecting the quote character to be escaped by doubling it. */
  double_quote?: boolean | null;
  /**
   * (CSV, XLSX only) Array of field names. Can be used to set field names
   * if they are missing in the file, but also to rewrite existing ones.
   * To rewrite existing ones, ignore_first_line must be set to true.
   *
   * Must be a `multipart/form-data` valid array - either multiple fields of
   * the given name, or a single field with comma (`,`) separated values.
   */
  field_names?: string[];
  /**
   * (CSV, XLSX only) Ignore first line in the file, false by default.
   * Can be used to replace header by a custom one (see `field_names`).
   * If header is not present, it will remove first data row!
   */
  ignore_first_line?: boolean | null;
  /**
   * The switch enables calling this endpoint with a non-existing
   * dataset name, resulting in dataset creation as if the POST method was used.
   */
  update_or_new?: boolean;
  /**
   * The names of the columns which are used for updating existing entities.
   * The keys can refer to a nested value using a
   * [dot notation](https://www.mongodb.com/docs/v5.0/core/document/#dot-notation).
   * E.g. `header.id`.
   *
   * Must be a `multipart/form-data` valid array - either multiple fields of
   * the given name, or a single field with comma (`,`) separated values.
   */
  id_keys: string[];
}

export interface LengthConstraint {
  min?: number | null;
  max?: number | null;
  exact?: number | null;
}

export interface RegexpConstraint {
  pattern: string;
}

export interface ValueConstraints {
  length?: LengthConstraint | null;
  regexp?: RegexpConstraint | null;
  required?: boolean;
}

export interface ButtonSchemaDatapointElement {
  category: 'datapoint';
  id: string;
  label: string;
  hidden?: boolean;
  disable_prediction?: boolean;
  type: 'button';
  can_export?: boolean;
  can_collapse?: boolean;
  rir_field_names?: string[] | null;
  default_value?: string | null;
  constraints?: ValueConstraints | null;
  width?: number | null;
  stretch?: boolean | null;
  score_threshold?: number | null;
  formula?: string | null;
  popup_url?: string | null;
  [key: string]: unknown;
}

export interface CSVParserConfig {
  field_delimiter?: string;
  escape_character?: string | null;
  quote_character?: string;
  double_quote?: boolean;
  field_names?: string[] | null;
  ignore_first_line?: boolean;
}

export interface ConstantPreferredResult {
  /**
   * Attribute name of the matched dataset entity. Can be specified using the
   * [JMESPath](https://jmespath.org/specification.html) syntax.
   */
  dataset_key: string;
  value?: unknown;
}

export type CreateSearchIndexRequestAnalyzers =
  | { [key: string]: unknown }[]
  | null;

export type CreateSearchIndexRequestMappings = { [key: string]: unknown };

export type CreateSearchIndexRequestSynonyms =
  | { [key: string]: unknown }[]
  | null;

export interface CreateSearchIndexRequest {
  collectionName: string;
  indexName: string;
  analyzer?: string | null;
  analyzers?: CreateSearchIndexRequestAnalyzers;
  mappings: CreateSearchIndexRequestMappings;
  searchAnalyzer?: string | null;
  synonyms?: CreateSearchIndexRequestSynonyms;
}

/**
 * MongoDB find command is used in the background.
 *
 * The query runtime is limited to 120 seconds.
 *
 * [MongoDB find documentation]
 * (https://www.mongodb.com/docs/manual/reference/method/db.collection.find/)
 */
export type FindFind = { [key: string]: unknown };

export type FindProjection = { [key: string]: unknown } | null;

export type FindSort = { [key: string]: unknown } | null;

export interface Find {
  /**
   * MongoDB find command is used in the background.
   *
   * The query runtime is limited to 120 seconds.
   *
   * [MongoDB find documentation]
   * (https://www.mongodb.com/docs/manual/reference/method/db.collection.find/)
   */
  find: FindFind;
  projection?: FindProjection;
  skip?: number;
  limit?: number;
  sort?: FindSort;
}

export interface DMDatasetSource {
  /**
   * The name of a dataset in which to perform the matching. The dataset
   * name can contain [placeholders](#section/Configuration-placeholders).
   */
  dataset: string;
  /**
   * List of queries to perform in the given order, until one of them finds a result.
   * The queries can contain [placeholders](#section/Configuration-placeholders).
   *
   * The syntax of the queries matches closely the one of
   * [MongoDB queries](https://www.mongodb.com/docs/manual/tutorial/query-documents/).
   * The query must be translated to a valid JSON: `{$or: [...]}` => `{"$or": [...]}`
   *
   * For example:
   * ```json
   * {
   *   "Name": {
   *     "$eq": "{sender_name}"
   *   }
   * }
   * ```
   * @minItems 1
   */
  queries: (Find | Aggregate)[];
}

export type DSResultsResponseResultsItem = { [key: string]: unknown };

export interface DSResultsResponse {
  results: DSResultsResponseResultsItem[];
}

export type SvcMasterDataHubWebApiModelsV1ResponseOperationStatus = typeof SvcMasterDataHubWebApiModelsV1ResponseOperationStatus[keyof typeof SvcMasterDataHubWebApiModelsV1ResponseOperationStatus];

export const SvcMasterDataHubWebApiModelsV1ResponseOperationStatus = {
  processing: 'processing',
  finished: 'finished',
  failed: 'failed',
  unknown: 'unknown',
  new: 'new',
  queued: 'queued',
} as const;

export interface Dataset {
  dataset_name: string;
  status: SvcMasterDataHubWebApiModelsV1ResponseOperationStatus;
  status_ts?: string | null;
}

/**
 * Custom metadata provided by the frontend
 */
export type DatasetAPISchemaMetadata = { [key: string]: unknown };

export type DatasetAPISchemaSearchIndexesItem = { [key: string]: unknown };

export interface DatasetJSONSchemaProperty {
  bson_type:
    | 'double'
    | 'string'
    | 'object'
    | 'array'
    | 'binData'
    | 'undefined'
    | 'objectId'
    | 'bool'
    | 'date'
    | 'null'
    | 'regex'
    | 'dbPointer'
    | 'javascript'
    | 'symbol'
    | 'javascriptWithScope'
    | 'int'
    | 'timestamp'
    | 'long'
    | 'decimal'
    | 'minKey'
    | 'maxKey'
    | (
        | 'double'
        | 'string'
        | 'object'
        | 'array'
        | 'binData'
        | 'undefined'
        | 'objectId'
        | 'bool'
        | 'date'
        | 'null'
        | 'regex'
        | 'dbPointer'
        | 'javascript'
        | 'symbol'
        | 'javascriptWithScope'
        | 'int'
        | 'timestamp'
        | 'long'
        | 'decimal'
        | 'minKey'
        | 'maxKey'
      )[];
  [key: string]: unknown;
}

export type DatasetJSONSchemaProperties = {
  [key: string]: DatasetJSONSchemaProperty;
};

export interface DatasetJSONSchema {
  bson_type?: string;
  properties?: DatasetJSONSchemaProperties;
  required?: string[] | null;
  [key: string]: unknown;
}

export type SchemaMode = typeof SchemaMode[keyof typeof SchemaMode];

export const SchemaMode = {
  inference: 'inference',
  validate: 'validate',
} as const;

export interface DatasetAPISchema {
  /** Name of the dataset (unique per organization). */
  name: string;
  /** Custom metadata provided by the frontend */
  metadata: DatasetAPISchemaMetadata;
  /** JSON schema of the dataset: inferred from imported data in `inference` mode, declared on create in `validate` mode (can be null only for newly created datasets without data). Limitations: top-level object only; one level of properties; nested objects/arrays are not represented. */
  schema?: DatasetJSONSchema | null;
  /** How imports treat the dataset's schema. `inference` rebuilds it from the imported data. `validate` makes the stored schema a contract: imports bind rows to it and fail on a violation. */
  schema_mode: SchemaMode;
  /** Search index definitions declared on the dataset registry; an empty list declares none. Writable on create; afterwards through the search_indexes subresource. */
  search_indexes: DatasetAPISchemaSearchIndexesItem[];
}

/**
 * Dataset metadata, stored as-is.
 */
export type DatasetCreateAPISchemaMetadata = { [key: string]: unknown } | null;

/**
 * A property whose declared type(s) imports can enforce; unknown keywords are refused.
 */
export interface DeclaredSchemaProperty {
  bson_type:
    | 'binData'
    | 'bool'
    | 'date'
    | 'decimal'
    | 'double'
    | 'int'
    | 'long'
    | 'null'
    | 'objectId'
    | 'string'
    | (
        | 'binData'
        | 'bool'
        | 'date'
        | 'decimal'
        | 'double'
        | 'int'
        | 'long'
        | 'null'
        | 'objectId'
        | 'string'
      )[];
}

export type DeclaredSchemaProperties = {
  [key: string]: DeclaredSchemaProperty;
};

/**
 * A client-written schema, accepted only if imports can enforce it as declared.
 */
export interface DeclaredSchema {
  bson_type?: 'object';
  properties: DeclaredSchemaProperties;
  required?: string[] | null;
}

export type StringFieldMappingInputIndexOptions =
  | typeof StringFieldMappingInputIndexOptions[keyof typeof StringFieldMappingInputIndexOptions]
  | null;

export const StringFieldMappingInputIndexOptions = {
  docs: 'docs',
  freqs: 'freqs',
  positions: 'positions',
  offsets: 'offsets',
} as const;

export type StringFieldMappingInputNorms =
  | typeof StringFieldMappingInputNorms[keyof typeof StringFieldMappingInputNorms]
  | null;

export const StringFieldMappingInputNorms = {
  include: 'include',
  omit: 'omit',
} as const;

export type MultiAnalyzerMappingInputIndexOptions =
  | typeof MultiAnalyzerMappingInputIndexOptions[keyof typeof MultiAnalyzerMappingInputIndexOptions]
  | null;

export const MultiAnalyzerMappingInputIndexOptions = {
  docs: 'docs',
  freqs: 'freqs',
  positions: 'positions',
  offsets: 'offsets',
} as const;

export type MultiAnalyzerMappingInputNorms =
  | typeof MultiAnalyzerMappingInputNorms[keyof typeof MultiAnalyzerMappingInputNorms]
  | null;

export const MultiAnalyzerMappingInputNorms = {
  include: 'include',
  omit: 'omit',
} as const;

/**
 * An alternate analyzer view of a string field (the ``multi`` option).
 */
export interface MultiAnalyzerMappingInput {
  indexOptions?: MultiAnalyzerMappingInputIndexOptions;
  store?: boolean | null;
  norms?: MultiAnalyzerMappingInputNorms;
  type: 'string';
  analyzer: string;
}

export type StringFieldMappingInputMulti = {
  [key: string]: MultiAnalyzerMappingInput;
} | null;

export interface StringFieldMappingInput {
  indexOptions?: StringFieldMappingInputIndexOptions;
  store?: boolean | null;
  norms?: StringFieldMappingInputNorms;
  type: 'string';
  analyzer?: string | null;
  searchAnalyzer?: string | null;
  multi?: StringFieldMappingInputMulti;
}

export type NumberFieldMappingInputRepresentation =
  | typeof NumberFieldMappingInputRepresentation[keyof typeof NumberFieldMappingInputRepresentation]
  | null;

export const NumberFieldMappingInputRepresentation = {
  int64: 'int64',
  double: 'double',
} as const;

export interface NumberFieldMappingInput {
  type: 'number';
  representation?: NumberFieldMappingInputRepresentation;
  indexDoubles?: boolean | null;
  indexIntegers?: boolean | null;
}

export type ScalarFieldMappingType = typeof ScalarFieldMappingType[keyof typeof ScalarFieldMappingType];

export const ScalarFieldMappingType = {
  date: 'date',
  boolean: 'boolean',
} as const;

export interface ScalarFieldMapping {
  type: ScalarFieldMappingType;
}

export type TokenFieldMappingNormalizer =
  | typeof TokenFieldMappingNormalizer[keyof typeof TokenFieldMappingNormalizer]
  | null;

export const TokenFieldMappingNormalizer = {
  lowercase: 'lowercase',
  none: 'none',
} as const;

/**
 * Whole-value indexing for exact matching, sorting and faceting.
 */
export interface TokenFieldMapping {
  type: 'token';
  normalizer?: TokenFieldMappingNormalizer;
}

export type DocumentFieldMappingInputFields = {
  [key: string]: FieldMappingInput | FieldMappingInput[];
} | null;

export interface DocumentFieldMappingInput {
  dynamic?: boolean | null;
  fields?: DocumentFieldMappingInputFields;
  type: 'document';
}

export interface StoredSource {
  include?: string[] | null;
  exclude?: string[] | null;
}

export type EmbeddedDocumentsFieldMappingInputFields = {
  [key: string]: FieldMappingInput | FieldMappingInput[];
} | null;

export interface EmbeddedDocumentsFieldMappingInput {
  dynamic?: boolean | null;
  fields?: EmbeddedDocumentsFieldMappingInputFields;
  type: 'embedded_documents';
  storedSource?: StoredSource | null;
}

export type FieldMappingInput =
  | StringFieldMappingInput
  | NumberFieldMappingInput
  | ScalarFieldMapping
  | TokenFieldMapping
  | AutocompleteFieldMappingInput
  | DocumentFieldMappingInput
  | EmbeddedDocumentsFieldMappingInput;

export type MappingsInputFields = {
  [key: string]: FieldMappingInput | FieldMappingInput[];
} | null;

export interface MappingsInput {
  dynamic?: boolean;
  fields?: MappingsInputFields;
}

export interface SynonymSource {
  /** @minLength 1 */
  collection: string;
}

/**
 * A synonym collection bound to the index (the ``synonyms`` option).
 *
 * The collection lives in the same database as the indexed one and holds the
 * synonym documents; the engine reads it, MDH neither writes nor imports it.
 */
export interface SynonymMapping {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  analyzer: string;
  source: SynonymSource;
}

/**
 * A search index definition, scoped to the configuration MDH actually supports.
 */
export interface SearchIndexDefinitionInput {
  mappings: MappingsInput;
  numPartitions?: number | null;
  storedSource?: boolean | StoredSource | null;
  analyzer?: string | null;
  searchAnalyzer?: string | null;
  analyzers?: AnalyzerInput[] | null;
  synonyms?: SynonymMapping[] | null;
}

/**
 * A named search index definition as declared on the dataset registry.
 */
export interface SearchIndexDeclarationInput {
  /** @pattern ^[A-Za-z0-9_-]+$ */
  name: string;
  definition: SearchIndexDefinitionInput;
}

export interface DatasetCreateAPISchema {
  /** Dataset metadata, stored as-is. */
  metadata?: DatasetCreateAPISchemaMetadata;
  /** Schema the dataset's data must fit; required in `validate` mode and refused with 400 in `inference` mode. Without `required`, every property is required. */
  schema?: DeclaredSchema | null;
  /** How imports treat the dataset's schema. `inference` rebuilds it from the imported data. `validate` makes the stored schema a contract: imports bind rows to it and fail on a violation. Omitted means `inference`. `validate` needs `schema`, otherwise 400. */
  schema_mode?: SchemaMode;
  /** Search indexes to declare on the new dataset. Omitted declares the default dynamic index named `default`, the one Atlas queries when a `$search` names none; `[]` declares no index at all. The engine builds them asynchronously, through the enqueued reconcile. */
  search_indexes?: SearchIndexDeclarationInput[] | null;
}

export type SvcMasterDataHubWebApiModelsV2ResponseOperationStatus = typeof SvcMasterDataHubWebApiModelsV2ResponseOperationStatus[keyof typeof SvcMasterDataHubWebApiModelsV2ResponseOperationStatus];

export const SvcMasterDataHubWebApiModelsV2ResponseOperationStatus = {
  WAITING: 'WAITING',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  FAILED: 'FAILED',
  UNKNOWN: 'UNKNOWN',
} as const;

export interface DatasetDTO {
  dataset_name: string;
  status: SvcMasterDataHubWebApiModelsV2ResponseOperationStatus;
  updated?: string | null;
}

/**
 * Row payload to insert. Top-level keys only. Forbidden keys: `id`, `_id`, `__digest_md5`, any key starting with `$`, any key containing `.`.
 */
export type PatchAddValue = { [key: string]: unknown };

export interface PatchAdd {
  op: 'add';
  /** Row payload to insert. Top-level keys only. Forbidden keys: `id`, `_id`, `__digest_md5`, any key starting with `$`, any key containing `.`. */
  value: PatchAddValue;
}

/**
 * Row payload to insert. Top-level keys only. Forbidden keys: `id`, `_id`, `__digest_md5`, any key starting with `$`, any key containing `.`.
 */
export type PatchReplaceValue = { [key: string]: unknown };

export interface PatchReplace {
  op: 'replace';
  /** MongoDB ObjectId of the row to update. */
  id: string;
  /** Row payload to insert. Top-level keys only. Forbidden keys: `id`, `_id`, `__digest_md5`, any key starting with `$`, any key containing `.`. */
  value: PatchReplaceValue;
}

export interface PatchRemove {
  op: 'remove';
  /** MongoDB ObjectId of the row to delete. */
  id: string;
}

/**
 * Bulk row-level patch request body for PATCH /v2/datasets/{name}/data.
 *
 * Synchronous validation rules beyond the JSON Schema (violation → 422):
 * - Each `id` may appear in at most one `replace`/`remove` operation across the batch.
 * - Each operation's `value` must not contain keys `id`/`_id`/`__digest_md5`, keys starting with `$`,
 *   or keys containing `.`.
 * Referenced rows that do not exist in the dataset → 400 with `ids` listing the missing ids.
 */
export interface DatasetDataPatchAPISchema {
  /**
   * 1-100 operations applied atomically. Each `id` may appear in at most one `replace`/`remove` operation across the batch.
   * @minItems 1
   * @maxItems 100
   */
  operations: (PatchAdd | PatchReplace | PatchRemove)[];
}

export type SvcMasterDataHubWebApiModelsV1ResponseOperationType = typeof SvcMasterDataHubWebApiModelsV1ResponseOperationType[keyof typeof SvcMasterDataHubWebApiModelsV1ResponseOperationType];

export const SvcMasterDataHubWebApiModelsV1ResponseOperationType = {
  upload: 'upload',
  replace: 'replace',
  delete: 'delete',
  update: 'update',
  upsert: 'upsert',
} as const;

export type FileFormat = typeof FileFormat[keyof typeof FileFormat];

export const FileFormat = {
  json: 'json',
  xml: 'xml',
  csv: 'csv',
  xlsx: 'xlsx',
} as const;

export interface XLSXParserConfig {
  field_names?: string[] | null;
  ignore_first_line?: boolean;
}

export interface FileMetadataOut {
  filename: string;
  file_format: FileFormat;
  file_size: number;
  file_encoding: string;
  dynamic_parsing?: boolean;
  parser_config?: CSVParserConfig | XLSXParserConfig | null;
}

export type ErrorInfoType = typeof ErrorInfoType[keyof typeof ErrorInfoType];

export const ErrorInfoType = {
  CLIENT_ERROR: 'CLIENT_ERROR',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  CRITICAL_ERROR: 'CRITICAL_ERROR',
  UNKNOWN: 'UNKNOWN',
} as const;

export interface ErrorInfo {
  type: ErrorInfoType;
  text: string;
}

export interface DatasetOperationOut {
  operation_type: SvcMasterDataHubWebApiModelsV1ResponseOperationType;
  operation_id: string;
  dataset_name: string;
  status: SvcMasterDataHubWebApiModelsV1ResponseOperationStatus;
  status_ts: string;
  create_ts: string;
  file_metadata: FileMetadataOut | null;
  error: ErrorInfo | null;
}

/**
 * Complete metadata replacement
 */
export type DatasetUpdateAPISchemaMetadata = { [key: string]: unknown } | null;

export interface DatasetUpdateAPISchema {
  /** Complete metadata replacement */
  metadata?: DatasetUpdateAPISchemaMetadata;
  /** How imports treat the dataset's schema. `inference` rebuilds it from the imported data. `validate` makes the stored schema a contract: imports bind rows to it and fail on a violation. Omitted leaves it unchanged. `validate` needs a non-empty schema, otherwise 400. */
  schema_mode?: SchemaMode | null;
}

export interface DatasetsDTO {
  datasets: DatasetDTO[];
}

export interface DatasetsPaginatedAPISchema {
  results: DatasetAPISchema[];
  /** Cursor for the next page, null if no more results */
  next_cursor?: string | null;
}

export interface DatasetsResponse {
  datasets: Dataset[];
}

export interface DateSchemaDatapointElement {
  category: 'datapoint';
  id: string;
  label: string;
  hidden?: boolean;
  disable_prediction?: boolean;
  type: 'date';
  can_export?: boolean;
  can_collapse?: boolean;
  rir_field_names?: string[] | null;
  default_value?: string | null;
  constraints?: ValueConstraints | null;
  width?: number | null;
  stretch?: boolean | null;
  score_threshold?: number | null;
  formula?: string | null;
  format?: string | null;
  [key: string]: unknown;
}

export type DocumentMetadata = { [key: string]: unknown } | null;

export interface Document {
  id: number;
  url: string;
  s3_name?: string;
  mime_type: string;
  original_file_name?: string;
  content: string | null;
  email?: string | null;
  metadata?: DocumentMetadata;
  parent?: string | null;
  annotations?: string[];
  attachment_status?: string | null;
  [key: string]: unknown;
}

export type StringFieldMappingOutputIndexOptions =
  | typeof StringFieldMappingOutputIndexOptions[keyof typeof StringFieldMappingOutputIndexOptions]
  | null;

export const StringFieldMappingOutputIndexOptions = {
  docs: 'docs',
  freqs: 'freqs',
  positions: 'positions',
  offsets: 'offsets',
} as const;

export type StringFieldMappingOutputNorms =
  | typeof StringFieldMappingOutputNorms[keyof typeof StringFieldMappingOutputNorms]
  | null;

export const StringFieldMappingOutputNorms = {
  include: 'include',
  omit: 'omit',
} as const;

export type MultiAnalyzerMappingOutputIndexOptions =
  | typeof MultiAnalyzerMappingOutputIndexOptions[keyof typeof MultiAnalyzerMappingOutputIndexOptions]
  | null;

export const MultiAnalyzerMappingOutputIndexOptions = {
  docs: 'docs',
  freqs: 'freqs',
  positions: 'positions',
  offsets: 'offsets',
} as const;

export type MultiAnalyzerMappingOutputNorms =
  | typeof MultiAnalyzerMappingOutputNorms[keyof typeof MultiAnalyzerMappingOutputNorms]
  | null;

export const MultiAnalyzerMappingOutputNorms = {
  include: 'include',
  omit: 'omit',
} as const;

/**
 * An alternate analyzer view of a string field (the ``multi`` option).
 */
export interface MultiAnalyzerMappingOutput {
  index_options?: MultiAnalyzerMappingOutputIndexOptions;
  store?: boolean | null;
  norms?: MultiAnalyzerMappingOutputNorms;
  type: 'string';
  analyzer: string;
}

export type StringFieldMappingOutputMulti = {
  [key: string]: MultiAnalyzerMappingOutput;
} | null;

export interface StringFieldMappingOutput {
  index_options?: StringFieldMappingOutputIndexOptions;
  store?: boolean | null;
  norms?: StringFieldMappingOutputNorms;
  type: 'string';
  analyzer?: string | null;
  search_analyzer?: string | null;
  multi?: StringFieldMappingOutputMulti;
}

export type NumberFieldMappingOutputRepresentation =
  | typeof NumberFieldMappingOutputRepresentation[keyof typeof NumberFieldMappingOutputRepresentation]
  | null;

export const NumberFieldMappingOutputRepresentation = {
  int64: 'int64',
  double: 'double',
} as const;

export interface NumberFieldMappingOutput {
  type: 'number';
  representation?: NumberFieldMappingOutputRepresentation;
  index_doubles?: boolean | null;
  index_integers?: boolean | null;
}

export interface DocumentFieldMappingOutput {
  dynamic?: boolean | null;
  fields?: DocumentFieldMappingOutputFields;
  type: 'document';
}

export type EmbeddedDocumentsFieldMappingOutputFields = {
  [key: string]: FieldMappingOutput | FieldMappingOutput[];
} | null;

export interface EmbeddedDocumentsFieldMappingOutput {
  dynamic?: boolean | null;
  fields?: EmbeddedDocumentsFieldMappingOutputFields;
  type: 'embedded_documents';
  stored_source?: StoredSource | null;
}

export type FieldMappingOutput =
  | StringFieldMappingOutput
  | NumberFieldMappingOutput
  | ScalarFieldMapping
  | TokenFieldMapping
  | AutocompleteFieldMappingOutput
  | DocumentFieldMappingOutput
  | EmbeddedDocumentsFieldMappingOutput;

export type DocumentFieldMappingOutputFields = {
  [key: string]: FieldMappingOutput | FieldMappingOutput[];
} | null;

export type DocumentSchemaMetadata = { [key: string]: unknown } | null;

export interface StringSchemaDatapointElement {
  category: 'datapoint';
  id: string;
  label: string;
  hidden?: boolean;
  disable_prediction?: boolean;
  type: 'string';
  can_export?: boolean;
  can_collapse?: boolean;
  rir_field_names?: string[] | null;
  default_value?: string | null;
  constraints?: ValueConstraints | null;
  width?: number | null;
  stretch?: boolean | null;
  score_threshold?: number | null;
  formula?: string | null;
  [key: string]: unknown;
}

export type NumberSchemaDatapointElementAggregations = {
  [key: string]: unknown;
} | null;

export interface NumberSchemaDatapointElement {
  category: 'datapoint';
  id: string;
  label: string;
  hidden?: boolean;
  disable_prediction?: boolean;
  type: 'number';
  can_export?: boolean;
  can_collapse?: boolean;
  rir_field_names?: string[] | null;
  default_value?: string | null;
  constraints?: ValueConstraints | null;
  width?: number | null;
  stretch?: boolean | null;
  score_threshold?: number | null;
  formula?: string | null;
  format?: string | null;
  aggregations?: NumberSchemaDatapointElementAggregations;
  [key: string]: unknown;
}

export type EnumValueType = typeof EnumValueType[keyof typeof EnumValueType];

export const EnumValueType = {
  string: 'string',
  number: 'number',
  date: 'date',
} as const;

export interface EnumSchemaDatapointElement {
  category: 'datapoint';
  id: string;
  label: string;
  hidden?: boolean;
  disable_prediction?: boolean;
  type: 'enum';
  can_export?: boolean;
  can_collapse?: boolean;
  rir_field_names?: string[] | null;
  default_value?: string | null;
  constraints?: ValueConstraints | null;
  width?: number | null;
  stretch?: boolean | null;
  score_threshold?: number | null;
  formula?: string | null;
  options: EnumOption[];
  enum_value_type?: EnumValueType;
  [key: string]: unknown;
}

export interface SchemaTupleElement {
  category: 'tuple';
  id: string;
  label: string;
  hidden?: boolean;
  disable_prediction?: boolean;
  children: (
    | StringSchemaDatapointElement
    | DateSchemaDatapointElement
    | NumberSchemaDatapointElement
    | EnumSchemaDatapointElement
    | ButtonSchemaDatapointElement
  )[];
  rir_field_names?: string[] | null;
  [key: string]: unknown;
}

export type RowType = typeof RowType[keyof typeof RowType];

export const RowType = {
  header: 'header',
  subsection_header: 'subsection_header',
  data: 'data',
  footer: 'footer',
} as const;

export interface Grid {
  row_types?: RowType[];
  default_row_type?: RowType;
  row_types_to_extract?: RowType[];
}

export interface SchemaMultivalueElement {
  category: 'multivalue';
  id: string;
  label: string;
  hidden?: boolean;
  disable_prediction?: boolean;
  children:
    | SchemaTupleElement
    | StringSchemaDatapointElement
    | DateSchemaDatapointElement
    | NumberSchemaDatapointElement
    | EnumSchemaDatapointElement
    | ButtonSchemaDatapointElement;
  min_occurrences?: number | null;
  max_occurrences?: number | null;
  grid?: Grid | null;
  show_grid_by_default?: boolean;
  rir_field_names?: string[] | null;
  [key: string]: unknown;
}

export interface SchemaSectionElement {
  category: 'section';
  id: string;
  label: string;
  hidden?: boolean;
  disable_prediction?: boolean;
  children: (
    | SchemaMultivalueElement
    | StringSchemaDatapointElement
    | DateSchemaDatapointElement
    | NumberSchemaDatapointElement
    | EnumSchemaDatapointElement
    | ButtonSchemaDatapointElement
  )[];
  icon?: string | null;
  [key: string]: unknown;
}

export interface DocumentSchema {
  id: number;
  name: string;
  url: string;
  queues: string[];
  content: SchemaSectionElement[];
  metadata?: DocumentSchemaMetadata;
}

export interface DropIndexRequest {
  collectionName: string;
  indexName: string;
}

export interface DynamicPreferredResult {
  /**
   * Attribute name of the matched dataset entity. Can be specified using the
   * [JMESPath](https://jmespath.org/specification.html) syntax.
   */
  dataset_key: string;
  schema_id: string;
}

export interface EJSONDate {
  $date: string;
}

export interface ResultMessage {
  type: MessageType;
  content: string;
}

export interface EmptyResultAction {
  /**
   * The only possible value for `no_match_found` is the default.
   * Therefore it can be omitted.
   */
  select?: 'default';
  message?: ResultMessage | null;
}

/**
 * MongoDB find command is used in the background.
 *
 * The query runtime is limited to 120 seconds.
 *
 * [MongoDB find documentation]
 * (https://www.mongodb.com/docs/manual/reference/method/db.collection.find/)
 */
export type FindBodyFind = { [key: string]: unknown };

export type FindBodyProjection = { [key: string]: unknown } | null;

export type FindBodySort = { [key: string]: unknown } | null;

export interface FindBody {
  /**
   * MongoDB find command is used in the background.
   *
   * The query runtime is limited to 120 seconds.
   *
   * [MongoDB find documentation]
   * (https://www.mongodb.com/docs/manual/reference/method/db.collection.find/)
   */
  find: FindBodyFind;
  projection?: FindBodyProjection;
  skip?: number;
  limit?: number;
  sort?: FindBodySort;
  dataset: string;
}

export interface HealthzResponse {
  code_version_hash: string;
  code_project_path: string;
}

export interface LatestDefinitionVersion {
  version: number;
  created_at?: string | null;
}

export interface ListIndexesRequest {
  collectionName: string;
  nameOnly?: boolean;
}

export type ListObjectsResponseResult = string[] | { [key: string]: unknown }[];

export interface ListObjectsResponse {
  code?: string;
  message: string;
  result: ListObjectsResponseResult;
}

export type LookupQueryAggregateItem = { [key: string]: unknown };

export type LookupQueryCollation = { [key: string]: unknown } | null;

export type LookupQueryLet = { [key: string]: unknown } | null;

export type LookupQueryOptions = { [key: string]: unknown } | null;

/**
 * Single lookup query — same shape as an aggregate query.
 */
export interface LookupQuery {
  /**
   * MongoDB aggregate command is used in the background.
   *
   * The query runtime is limited to 120 seconds.
   *
   * [MongoDB aggregate documentation]
   * (https://www.mongodb.com/docs/manual/reference/method/db.collection.aggregate/)
   *
   * If there is no $limit stage specified after a $search stage, the default limit of 50
   * will be used.
   * @minItems 1
   */
  aggregate: LookupQueryAggregateItem[];
  collation?: LookupQueryCollation;
  let?: LookupQueryLet;
  options?: LookupQueryOptions;
}

/**
 * Batch lookup request: one dataset, one or many queries.
 */
export interface LookupBody {
  dataset: string;
  /**
   * @minItems 1
   * @maxItems 32
   */
  queries: LookupQuery[];
}

export type LookupResultItemResultsItem = { [key: string]: unknown };

export interface LookupResultItem {
  results?: LookupResultItemResultsItem[];
  error?: string | null;
}

export interface LookupResponse {
  results: LookupResultItem[];
}

export interface Mapping {
  /**
   * Schema ID of the annotation field to put the match result in.
   * The field must be of type ENUM.
   */
  target_schema_id: string;
  /**
   * Attribute name of the matched dataset entity. Its value will be put in the target field.
   *
   * It is possible to access the matched entity attributes using the
   * [JMESPath](https://jmespath.org/specification.html) syntax. You can utilize the full
   * syntax to control what ends up in the target field.
   *
   * For example:
   *
   * `"dataset_key": ""First Name" | '---'"`
   * with a matched dataset entity with either a missing or an empty `First Name` attribute:
   * ```
   * {
   *   "Company Name": "My Vendor 123",
   *   "First Name": ""
   * }
   * ```
   * Will result in the value `---` being saved in the target field, instead of an empty string.
   */
  dataset_key: string;
  /**
   * [DEPRECATED] - Use `label_template` instead.
   *
   * Keys of the matched dataset entity to use as the resulting enum option label.
   * The values will be joined by a ', ' delimiter.
   */
  label_keys?: string[];
  /**
   * Template to use for the resulting enum option label.
   *
   * Template can contain references to the keys of the matched dataset entity.
   * It is possible to access nested data by using
   * [JMESPath](https://jmespath.org/specification.html) syntax.
   *
   * For example:
   *
   * `"label_template": "Supplier: {Supplier.\"Full Name\"} (VAT: {\"VAT ID\"})"`
   * with a matched dataset entity like this:
   * ```
   * {
   *   "Supplier": {
   *     "Full Name": "John Doe"
   *   },
   *   "VAT ID": "123456789"
   * }
   * ```
   * Will result in the following label: "Supplier: John Doe (VAT: 123456789)"
   *
   * If the parameter is not specified, the value from `dataset_key`
   * is displayed in the field label.
   */
  label_template?: string | null;
}

export type MappingsOutputFields = {
  [key: string]: FieldMappingOutput | FieldMappingOutput[];
} | null;

export interface MappingsOutput {
  dynamic?: boolean;
  fields?: MappingsOutputFields;
}

export type Method = typeof Method[keyof typeof Method];

export const Method = {
  GET: 'GET',
  POST: 'POST',
} as const;

/**
 * The headers to be sent with the request. They can contain
 * [placeholders](#section/Configuration-placeholders).
 *
 * For example:
 * ```json
 * {
 *   "Authorization": "Basic {secrets.credentials}"
 * }
 * ```
 */
export type RestAPIRequestHeaders = { [key: string]: string | number | null };

/**
 * The URL query parameters to be sent in the form of a dictionary. They can contain
 * [placeholders](#section/Configuration-placeholders).
 *
 * For example:
 * ```json
 * {
 *   "poNumber": "{po_number}",
 *   "lineItemCode": "{item_code}"
 * }
 * ```
 * will be sent as a URL query like this: `?poNumber=PO1234&lineItemCode=A002`
 */
export type RestAPIRequestQueryParams = {
  [key: string]: string | number | boolean | null;
};

/**
 * The body of the request to be sent. It can contain
 * [placeholders](#section/Configuration-placeholders).
 *
 * For example:
 * ```json
 * {
 *   "poNumber": "{po_number}",
 *   "lineItemCode": "{item_code}"
 * }
 * ```
 */
export type RestAPIRequestBody = { [key: string]: unknown } | null;

export interface RestAPIRequest {
  /**
   * The URL of the resource to be requested. It can contain
   * [placeholders](#section/Configuration-placeholders).
   *
   * Example: `https://app.com/api/purchase-order/{po_number}`
   */
  url: string;
  /** HTTP method to use. Can be either GET or POST. */
  method: Method;
  /**
   * The headers to be sent with the request. They can contain
   * [placeholders](#section/Configuration-placeholders).
   *
   * For example:
   * ```json
   * {
   *   "Authorization": "Basic {secrets.credentials}"
   * }
   * ```
   */
  headers?: RestAPIRequestHeaders;
  /**
   * The URL query parameters to be sent in the form of a dictionary. They can contain
   * [placeholders](#section/Configuration-placeholders).
   *
   * For example:
   * ```json
   * {
   *   "poNumber": "{po_number}",
   *   "lineItemCode": "{item_code}"
   * }
   * ```
   * will be sent as a URL query like this: `?poNumber=PO1234&lineItemCode=A002`
   */
  query_params?: RestAPIRequestQueryParams;
  /**
   * The body of the request to be sent. It can contain
   * [placeholders](#section/Configuration-placeholders).
   *
   * For example:
   * ```json
   * {
   *   "poNumber": "{po_number}",
   *   "lineItemCode": "{item_code}"
   * }
   * ```
   */
  body?: RestAPIRequestBody;
}

/**
 * The headers to be sent with the request. They can contain
 * [placeholders](#section/Configuration-placeholders).
 *
 * For example:
 * ```json
 * {
 *   "Authorization": "Basic {secrets.credentials}"
 * }
 * ```
 */
export type RestAPIQueryHeaders = { [key: string]: string | number | null };

/**
 * The URL query parameters to be sent in the form of a dictionary. They can contain
 * [placeholders](#section/Configuration-placeholders).
 *
 * For example:
 * ```json
 * {
 *   "poNumber": "{po_number}",
 *   "lineItemCode": "{item_code}"
 * }
 * ```
 * will be sent as a URL query like this: `?poNumber=PO1234&lineItemCode=A002`
 */
export type RestAPIQueryQueryParams = {
  [key: string]: string | number | boolean | null;
};

/**
 * The body of the request to be sent. It can contain
 * [placeholders](#section/Configuration-placeholders).
 *
 * For example:
 * ```json
 * {
 *   "poNumber": "{po_number}",
 *   "lineItemCode": "{item_code}"
 * }
 * ```
 */
export type RestAPIQueryBody = { [key: string]: unknown } | null;

export interface RestAPIQuery {
  /**
   * The URL of the resource to be requested. It can contain
   * [placeholders](#section/Configuration-placeholders).
   *
   * Example: `https://app.com/api/purchase-order/{po_number}`
   */
  url: string;
  /** HTTP method to use. Can be either GET or POST. */
  method: Method;
  /**
   * The headers to be sent with the request. They can contain
   * [placeholders](#section/Configuration-placeholders).
   *
   * For example:
   * ```json
   * {
   *   "Authorization": "Basic {secrets.credentials}"
   * }
   * ```
   */
  headers?: RestAPIQueryHeaders;
  /**
   * The URL query parameters to be sent in the form of a dictionary. They can contain
   * [placeholders](#section/Configuration-placeholders).
   *
   * For example:
   * ```json
   * {
   *   "poNumber": "{po_number}",
   *   "lineItemCode": "{item_code}"
   * }
   * ```
   * will be sent as a URL query like this: `?poNumber=PO1234&lineItemCode=A002`
   */
  query_params?: RestAPIQueryQueryParams;
  /**
   * The body of the request to be sent. It can contain
   * [placeholders](#section/Configuration-placeholders).
   *
   * For example:
   * ```json
   * {
   *   "poNumber": "{po_number}",
   *   "lineItemCode": "{item_code}"
   * }
   * ```
   */
  body?: RestAPIQueryBody;
  /**
   * A [JMESPath](https://jmespath.org/specification.html) expression
   * specifying how to access the results in the response body.
   *
   * For example:
   * The result items returned in the response body like this
   * ```json
   * {
   *   "result": {
   *     "items": [...]
   *   },
   *   "metadata": {...}
   * }
   * ```
   * can be accessed using the path `result.items`.
   *
   * An empty path can be used to select the whole response body.
   */
  result_path: string;
}

export interface RestAPISource {
  /**
   * An optional authentication request. The response can be referenced in the
   * following queries using auth [placeholders](#section/Configuration-placeholders).
   */
  auth?: RestAPIRequest | null;
  /**
   * List of API requests to perform in the given order, until one of them finds a result.
   * Each query must return an object or a list of objects. The server must respond within
   * 5 seconds. If the server fails to respond (connection cannot be established, times out
   * after 5 seconds, or responds with a 500 status code), the query is retried once after
   * 3 seconds.
   * @minItems 1
   */
  queries: RestAPIQuery[];
}

export type SelectOption = typeof SelectOption[keyof typeof SelectOption];

export const SelectOption = {
  default: 'default',
  best_match: 'best_match',
  best_match_include_default: 'best_match_include_default',
} as const;

export interface ResultAction {
  /**
   * What to preselect in the target ENUM annotation field.
   * The default can be specified in the `default` part of the configuration.
   *
   * If the `best_match` option is configured, the default option will not be present
   * in the list of options at all. To include the default option, while also preselecting
   * the best match, set the option to `best_match_include_default`.
   */
  select: SelectOption;
  message?: ResultMessage | null;
}

export interface ResultActions {
  no_match_found: EmptyResultAction;
  one_match_found: ResultAction;
  multiple_matches_found: ResultAction;
}

export interface MatchConfig {
  /** Source of the data in which the matching should be performed. */
  source: DMDatasetSource | RestAPISource;
  /** Describes how to map the found result to the annotation fields. */
  mapping: Mapping;
  /**
   * Map additional fields of the found result to different annotation fields
   * to match from the query result. Changing the selected value of the main
   * mapping will also change the value of the additional mappings.
   */
  additional_mappings?: Mapping[];
  /**
   * Definition of a condition for the particular matching. When defined,
   * the matching will be performed only if the condition is evaluated to True,
   * otherwise the matching targets will be reset.
   *
   * **Warning:** The condition is evaluated when selecting a value in the main
   * mapping as well. This means that if the condition turns out to be False,
   * the additional mappings will not be updated!
   *
   * If the matching query is defined on header level and the condition on
   * a table level, all rows must pass the condition in order for the matching
   * to be performed. If the matching query as well as the condition are defined
   * on table level, the matching will be performed only for the rows which pass
   * the condition.
   *
   * It must be a Pythonic expression where annotation fields are referenced
   * by their schema ID enclosed in curly brackets.
   * Example: `'{item_code}' != '' and '{document_type}' == 'invoice'`
   */
  action_condition?: string;
  /**
   * Definition of one of the results, that should always be put to the top of the matching
   * results. Can be either a constant value or a dynamically evaluated value from the
   * document's annotation data.
   */
  preferred_result?: DynamicPreferredResult | ConstantPreferredResult | null;
  /**
   * The actions describe what to do when either no, one or multiple entities
   * were found in the dataset by the specified queries.
   */
  result_actions: ResultActions;
  /**
   * The default value and label to put in the target annotation field
   * if no matches are found or if configured in the `result_actions`.
   */
  default: EnumOption;
  /**
   * IDs of queues where the matching should be performed.
   * You can assign the extension to multiple queues and
   * specify numerous actions for different queues in one instance.
   *
   * If not present, matching will be performed on all the queues
   * to which the extension is assigned unless `excluded_queue_ids` is set.
   */
  queue_ids?: number[];
  /**
   * IDs of queues where the matching won't be performed.
   * This parameter cannot be set along with 'queue_ids'.
   */
  excluded_queue_ids?: number[];
}

export interface MatchConfigs {
  /** List of matching configurations, performed in the specified order. */
  configurations: MatchConfig[];
}

export type MatchEventSecrets = { [key: string]: unknown };

export type MatchEventFeatures = { [key: string]: unknown } | null;

export type QueueMetadata = { [key: string]: unknown };

export interface Queue {
  id: number;
  name: string;
  url: string;
  workspace: string;
  hooks?: string[];
  webhooks?: string[];
  schema: string;
  metadata: QueueMetadata;
  [key: string]: unknown;
}

export interface MatchEvent {
  request_id: string;
  timestamp: string;
  hook: string;
  action: AnnotationContentAction;
  event: 'annotation_content';
  rossum_authorization_token: string;
  base_url: string;
  settings: MatchConfigs;
  secrets?: MatchEventSecrets;
  features?: MatchEventFeatures;
  schemas?: DocumentSchema[] | null;
  queues?: Queue[] | null;
  document: Document;
  annotation: AnnotationWithContent;
  updated_datapoints: number[];
  [key: string]: unknown;
}

export interface MessageResponse {
  message: string;
  type: MessageType;
}

export type OperationSummaryReplaceMode =
  | typeof OperationSummaryReplaceMode[keyof typeof OperationSummaryReplaceMode]
  | null;

export const OperationSummaryReplaceMode = {
  delta: 'delta',
  full: 'full',
  update: 'update',
  partial: 'partial',
  none: 'none',
} as const;

export interface OperationSummary {
  record_count?: number;
  bytes?: number;
  duration_s?: number | null;
  replace_mode?: OperationSummaryReplaceMode;
  replace_reason?: string | null;
  mongo_duration_s?: number | null;
  documents_changed?: number | null;
}

export type SharedDatasetManagerDatasetSchemaEncoderSchemaViolationCode = typeof SharedDatasetManagerDatasetSchemaEncoderSchemaViolationCode[keyof typeof SharedDatasetManagerDatasetSchemaEncoderSchemaViolationCode];

export const SharedDatasetManagerDatasetSchemaEncoderSchemaViolationCode = {
  unknown_field: 'unknown_field',
  missing_field: 'missing_field',
  type_mismatch: 'type_mismatch',
} as const;

/**
 * A bind error at one row of an import; ``row`` is 1-based among the non-empty data rows.
 */
export interface SharedDatasetManagerDatasetSchemaEncoderSchemaViolation {
  row: number;
  field: string;
  code: SharedDatasetManagerDatasetSchemaEncoderSchemaViolationCode;
  message: string;
}

export interface Metadata {
  operation_summary?: OperationSummary;
  schema_violations?:
    | SharedDatasetManagerDatasetSchemaEncoderSchemaViolation[]
    | null;
  [key: string]: unknown;
}

export type SharedDataStorageApiModelsResponseOperationStatus = typeof SharedDataStorageApiModelsResponseOperationStatus[keyof typeof SharedDataStorageApiModelsResponseOperationStatus];

export const SharedDataStorageApiModelsResponseOperationStatus = {
  CREATED: 'CREATED',
  RUNNING: 'RUNNING',
  FINISHED: 'FINISHED',
  FAILED: 'FAILED',
} as const;

export interface Operation {
  _id: string;
  user_id: string;
  status: SharedDataStorageApiModelsResponseOperationStatus;
  operation: string;
  last_updated: EJSONDate;
  error_message?: string | null;
}

export interface OperationContent {
  [key: string]: unknown;
}

export type OperationLogErrorType =
  | typeof OperationLogErrorType[keyof typeof OperationLogErrorType]
  | null;

export const OperationLogErrorType = {
  CLIENT_ERROR: 'CLIENT_ERROR',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  CRITICAL_ERROR: 'CRITICAL_ERROR',
  UNKNOWN: 'UNKNOWN',
} as const;

export type SharedDatasetManagerRepositoryOperationLogModelOperationType = typeof SharedDatasetManagerRepositoryOperationLogModelOperationType[keyof typeof SharedDatasetManagerRepositoryOperationLogModelOperationType];

export const SharedDatasetManagerRepositoryOperationLogModelOperationType = {
  create: 'create',
  update: 'update',
  replace: 'replace',
  delete: 'delete',
  partial_update: 'partial_update',
  unknown: 'unknown',
} as const;

/**
 * Status of the operation persisted in the operations log (collection).
 *
 * WAITING status is optional and might be skipped. Could be used by extensions
 * that create the operation to be processed later. See DatasetManager.prepare().
 */
export type SharedDatasetManagerRepositoryOperationLogModelOperationStatus = typeof SharedDatasetManagerRepositoryOperationLogModelOperationStatus[keyof typeof SharedDatasetManagerRepositoryOperationLogModelOperationStatus];

export const SharedDatasetManagerRepositoryOperationLogModelOperationStatus = {
  WAITING: 'WAITING',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  FAILED: 'FAILED',
  UNKNOWN: 'UNKNOWN',
} as const;

/**
 * Persisted state of an operation.
 *
 * All fields are managed by DatasetManager, except for the metadata, that can
 * be used to store any user data. They can be provided during preparation stage,
 * see DatasetManager.prepare().
 */
export interface OperationLog {
  _id?: string;
  source?: string;
  organization_uuid?: string;
  organization_uid?: string;
  dataset_name: string;
  type: SharedDatasetManagerRepositoryOperationLogModelOperationType;
  status?: SharedDatasetManagerRepositoryOperationLogModelOperationStatus;
  message?: string | null;
  error_type?: OperationLogErrorType;
  created?: string;
  started?: string | null;
  updated?: string;
  metadata: Metadata;
}

export interface OperationStatusResponse {
  code?: string;
  message: string;
  result: Operation;
}

export interface OperationsDTO {
  operations: OperationLog[];
}

export interface OperationsResponse {
  operations: DatasetOperationOut[];
}

export interface PatchDocumentsNotFoundError {
  message?: string;
  type?: 'error';
  ids: string[];
}

export interface PatchOperationInProgressError {
  message?: string;
  type?: 'error';
  /** Id of the operation currently running on the dataset. */
  operation_id: string;
}

export interface PatchSchemaNotFoundError {
  message?: string;
  type?: 'error';
}

export type SvcMasterDataHubWebApiModelsV2DatasetsSchemaViolationCode = typeof SvcMasterDataHubWebApiModelsV2DatasetsSchemaViolationCode[keyof typeof SvcMasterDataHubWebApiModelsV2DatasetsSchemaViolationCode];

export const SvcMasterDataHubWebApiModelsV2DatasetsSchemaViolationCode = {
  unknown_field: 'unknown_field',
  missing_field: 'missing_field',
  type_mismatch: 'type_mismatch',
} as const;

export interface SvcMasterDataHubWebApiModelsV2DatasetsSchemaViolation {
  /** Index of the offending operation in the request's `operations` array. */
  op_index: number;
  /** Field path within `operations[op_index].value` that failed validation. */
  field: string;
  code: SvcMasterDataHubWebApiModelsV2DatasetsSchemaViolationCode;
  message: string;
}

export interface PatchSchemaViolationError {
  message?: string;
  type?: 'error';
  violations: SvcMasterDataHubWebApiModelsV2DatasetsSchemaViolation[];
}

/**
 * A search index definition, scoped to the configuration MDH actually supports.
 */
export interface SearchIndexDefinitionOutput {
  mappings: MappingsOutput;
  num_partitions?: number | null;
  stored_source?: boolean | StoredSource | null;
  analyzer?: string | null;
  search_analyzer?: string | null;
  analyzers?: AnalyzerOutput[] | null;
  synonyms?: SynonymMapping[] | null;
}

/**
 * A named search index definition as declared on the dataset registry.
 */
export interface SearchIndexDeclarationOutput {
  /** @pattern ^[A-Za-z0-9_-]+$ */
  name: string;
  definition: SearchIndexDefinitionOutput;
}

/**
 * ``PENDING_*`` are MDH-derived sync states (registry ahead of engine); the rest are engine values, verbatim.
 */
export type SearchIndexStatus = typeof SearchIndexStatus[keyof typeof SearchIndexStatus];

export const SearchIndexStatus = {
  PENDING_CREATE: 'PENDING_CREATE',
  PENDING_UPDATE: 'PENDING_UPDATE',
  PENDING_DELETE: 'PENDING_DELETE',
  PENDING: 'PENDING',
  BUILDING: 'BUILDING',
  READY: 'READY',
  STALE: 'STALE',
  FAILED: 'FAILED',
} as const;

export type SearchIndexWithStatusDefinition =
  | SearchIndexDefinitionOutput
  | { [key: string]: unknown };

/**
 * Registry declaration overlaid with the live engine fields.
 *
 * For an engine-only index ``definition`` is the engine's normalized
 * definition, passed through verbatim (camelCase, display-only).
 */
export interface SearchIndexWithStatus {
  name: string;
  definition: SearchIndexWithStatusDefinition;
  queryable: boolean;
  status: SearchIndexStatus;
  latest_definition_version?: LatestDefinitionVersion | null;
}

export type GetOperationsApiV1OperationGetParams = {
  dataset_name?: string | null;
  /**
   * @minimum 1
   * @maximum 5000
   */
  limit?: number;
};

export type DsProxyAggregateApiV1DataAggregatePostParams = {
  create_missing_search_indexes?: boolean;
};

export type GetOperationsApiV2OperationGetParams = {
  dataset_name?: string | null;
  /**
   * @minimum 1
   * @maximum 5000
   */
  limit?: number;
};

export type GetDatasetsApiV2DatasetsGetParams = {
  /**
   * Pagination cursor, must be in ObjectId format.
   */
  cursor?: string | null;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
};

export type ExportDatasetApiV2DatasetsDatasetNameDataGetParams = {
  /**
   * Leave MDH's internal fields (`_id`, `__digest_md5`) out of the exported rows, so the file
   * holds the dataset's own columns and nothing else. Use it for a file meant to be read in a
   * spreadsheet, or edited and uploaded back: an upload that carries `_id` forces a full
   * collection rebuild instead of an in-place delta. Omit it when you need `_id` to address
   * individual rows through `PATCH /datasets/{dataset_name}/data`.
   */
  exclude_internal_fields?: boolean;
};

export const getMasterDataHub = (axiosInstance: AxiosInstance = axios) => {
  /**
   * @summary Get Metrics
   */
  const getMetricsMetricsGet = (
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<unknown>> => {
    return axiosInstance.get(`/svc/master-data-hub/metrics`, options);
  };

  /**
   * See if API is alive.
   * @summary Healthz
   */
  const healthzApiHealthzGet = (
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<HealthzResponse>> => {
    return axiosInstance.get(`/svc/master-data-hub/api/healthz`, options);
  };

  /**
   * Upload a new dataset.
   *
   * Dataset name must be unique in your organization.
   *
   * Maximum supported file size is 50MB.
   * @summary Create Dataset
   */
  const createDatasetApiV1DatasetDatasetNamePost = (
    datasetName: string,
    bodyCreateDatasetApiV1DatasetDatasetNamePost: BodyCreateDatasetApiV1DatasetDatasetNamePost,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MessageResponse>> => {
    const formData = new FormData();
    formData.append(`file`, bodyCreateDatasetApiV1DatasetDatasetNamePost.file);
    formData.append(
      `encoding`,
      bodyCreateDatasetApiV1DatasetDatasetNamePost.encoding
    );
    if (bodyCreateDatasetApiV1DatasetDatasetNamePost.dynamic !== undefined) {
      formData.append(
        `dynamic`,
        bodyCreateDatasetApiV1DatasetDatasetNamePost.dynamic.toString()
      );
    }
    if (
      bodyCreateDatasetApiV1DatasetDatasetNamePost.field_delimiter !==
        undefined &&
      bodyCreateDatasetApiV1DatasetDatasetNamePost.field_delimiter !== null
    ) {
      formData.append(
        `field_delimiter`,
        bodyCreateDatasetApiV1DatasetDatasetNamePost.field_delimiter
      );
    }
    if (
      bodyCreateDatasetApiV1DatasetDatasetNamePost.escape_character !==
        undefined &&
      bodyCreateDatasetApiV1DatasetDatasetNamePost.escape_character !== null
    ) {
      formData.append(
        `escape_character`,
        bodyCreateDatasetApiV1DatasetDatasetNamePost.escape_character
      );
    }
    if (
      bodyCreateDatasetApiV1DatasetDatasetNamePost.quote_character !==
        undefined &&
      bodyCreateDatasetApiV1DatasetDatasetNamePost.quote_character !== null
    ) {
      formData.append(
        `quote_character`,
        bodyCreateDatasetApiV1DatasetDatasetNamePost.quote_character
      );
    }
    if (
      bodyCreateDatasetApiV1DatasetDatasetNamePost.double_quote !== undefined &&
      bodyCreateDatasetApiV1DatasetDatasetNamePost.double_quote !== null
    ) {
      formData.append(
        `double_quote`,
        bodyCreateDatasetApiV1DatasetDatasetNamePost.double_quote.toString()
      );
    }
    if (
      bodyCreateDatasetApiV1DatasetDatasetNamePost.field_names !== undefined
    ) {
      bodyCreateDatasetApiV1DatasetDatasetNamePost.field_names.forEach(value =>
        formData.append(`field_names`, value)
      );
    }
    if (
      bodyCreateDatasetApiV1DatasetDatasetNamePost.ignore_first_line !==
        undefined &&
      bodyCreateDatasetApiV1DatasetDatasetNamePost.ignore_first_line !== null
    ) {
      formData.append(
        `ignore_first_line`,
        bodyCreateDatasetApiV1DatasetDatasetNamePost.ignore_first_line.toString()
      );
    }

    return axiosInstance.post(
      `/svc/master-data-hub/api/v1/dataset/${datasetName}`,
      formData,
      options
    );
  };

  /**
   * Fully replace an existing dataset.
   * @summary Replace Dataset
   */
  const replaceDatasetApiV1DatasetDatasetNamePut = (
    datasetName: string,
    bodyReplaceDatasetApiV1DatasetDatasetNamePut: BodyReplaceDatasetApiV1DatasetDatasetNamePut,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MessageResponse>> => {
    const formData = new FormData();
    formData.append(`file`, bodyReplaceDatasetApiV1DatasetDatasetNamePut.file);
    formData.append(
      `encoding`,
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.encoding
    );
    if (bodyReplaceDatasetApiV1DatasetDatasetNamePut.dynamic !== undefined) {
      formData.append(
        `dynamic`,
        bodyReplaceDatasetApiV1DatasetDatasetNamePut.dynamic.toString()
      );
    }
    if (
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.field_delimiter !==
        undefined &&
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.field_delimiter !== null
    ) {
      formData.append(
        `field_delimiter`,
        bodyReplaceDatasetApiV1DatasetDatasetNamePut.field_delimiter
      );
    }
    if (
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.escape_character !==
        undefined &&
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.escape_character !== null
    ) {
      formData.append(
        `escape_character`,
        bodyReplaceDatasetApiV1DatasetDatasetNamePut.escape_character
      );
    }
    if (
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.quote_character !==
        undefined &&
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.quote_character !== null
    ) {
      formData.append(
        `quote_character`,
        bodyReplaceDatasetApiV1DatasetDatasetNamePut.quote_character
      );
    }
    if (
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.double_quote !== undefined &&
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.double_quote !== null
    ) {
      formData.append(
        `double_quote`,
        bodyReplaceDatasetApiV1DatasetDatasetNamePut.double_quote.toString()
      );
    }
    if (
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.field_names !== undefined
    ) {
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.field_names.forEach(value =>
        formData.append(`field_names`, value)
      );
    }
    if (
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.ignore_first_line !==
        undefined &&
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.ignore_first_line !== null
    ) {
      formData.append(
        `ignore_first_line`,
        bodyReplaceDatasetApiV1DatasetDatasetNamePut.ignore_first_line.toString()
      );
    }
    if (
      bodyReplaceDatasetApiV1DatasetDatasetNamePut.replace_or_new !== undefined
    ) {
      formData.append(
        `replace_or_new`,
        bodyReplaceDatasetApiV1DatasetDatasetNamePut.replace_or_new.toString()
      );
    }

    return axiosInstance.put(
      `/svc/master-data-hub/api/v1/dataset/${datasetName}`,
      formData,
      options
    );
  };

  /**
   * Add new and update existing entities in a dataset,
   * without removing any existing entities.
   * @summary Update Dataset
   */
  const updateDatasetApiV1DatasetDatasetNamePatch = (
    datasetName: string,
    bodyUpdateDatasetApiV1DatasetDatasetNamePatch: BodyUpdateDatasetApiV1DatasetDatasetNamePatch,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MessageResponse>> => {
    const formData = new FormData();
    formData.append(`file`, bodyUpdateDatasetApiV1DatasetDatasetNamePatch.file);
    formData.append(
      `encoding`,
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.encoding
    );
    if (bodyUpdateDatasetApiV1DatasetDatasetNamePatch.dynamic !== undefined) {
      formData.append(
        `dynamic`,
        bodyUpdateDatasetApiV1DatasetDatasetNamePatch.dynamic.toString()
      );
    }
    if (
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.field_delimiter !==
        undefined &&
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.field_delimiter !== null
    ) {
      formData.append(
        `field_delimiter`,
        bodyUpdateDatasetApiV1DatasetDatasetNamePatch.field_delimiter
      );
    }
    if (
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.escape_character !==
        undefined &&
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.escape_character !== null
    ) {
      formData.append(
        `escape_character`,
        bodyUpdateDatasetApiV1DatasetDatasetNamePatch.escape_character
      );
    }
    if (
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.quote_character !==
        undefined &&
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.quote_character !== null
    ) {
      formData.append(
        `quote_character`,
        bodyUpdateDatasetApiV1DatasetDatasetNamePatch.quote_character
      );
    }
    if (
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.double_quote !==
        undefined &&
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.double_quote !== null
    ) {
      formData.append(
        `double_quote`,
        bodyUpdateDatasetApiV1DatasetDatasetNamePatch.double_quote.toString()
      );
    }
    if (
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.field_names !== undefined
    ) {
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.field_names.forEach(value =>
        formData.append(`field_names`, value)
      );
    }
    if (
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.ignore_first_line !==
        undefined &&
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.ignore_first_line !== null
    ) {
      formData.append(
        `ignore_first_line`,
        bodyUpdateDatasetApiV1DatasetDatasetNamePatch.ignore_first_line.toString()
      );
    }
    if (
      bodyUpdateDatasetApiV1DatasetDatasetNamePatch.update_or_new !== undefined
    ) {
      formData.append(
        `update_or_new`,
        bodyUpdateDatasetApiV1DatasetDatasetNamePatch.update_or_new.toString()
      );
    }
    bodyUpdateDatasetApiV1DatasetDatasetNamePatch.id_keys.forEach(value =>
      formData.append(`id_keys`, value)
    );

    return axiosInstance.patch(
      `/svc/master-data-hub/api/v1/dataset/${datasetName}`,
      formData,
      options
    );
  };

  /**
   * Delete an existing dataset.
   *
   * **Warning**: all indexes and aliases will be lost!
   * @summary Delete Dataset
   */
  const deleteDatasetApiV1DatasetDatasetNameDelete = (
    datasetName: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MessageResponse>> => {
    return axiosInstance.delete(
      `/svc/master-data-hub/api/v1/dataset/${datasetName}`,
      options
    );
  };

  /**
   * List all datasets and their status.
   * @summary Get Datasets
   */
  const getDatasetsApiV1DatasetGet = (
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DatasetsResponse>> => {
    return axiosInstance.get(`/svc/master-data-hub/api/v1/dataset/`, options);
  };

  /**
   * Perform matching using the supplied configuration.
   *
   * This endpoint is supposed to be triggered by Rossum.
   * @summary Match
   */
  const matchApiV1MatchPost = (
    matchEvent: MatchEvent,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<AnnotationContentHookResponse | void>> => {
    return axiosInstance.post(
      `/svc/master-data-hub/api/v1/match`,
      matchEvent,
      options
    );
  };

  /**
   * Retrieve a previously created dataset operation by its ID.
   * @summary Get Operation
   */
  const getOperationApiV1OperationOperationIdGet = (
    operationId: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DatasetOperationOut>> => {
    return axiosInstance.get(
      `/svc/master-data-hub/api/v1/operation/${operationId}`,
      options
    );
  };

  /**
   * Retrieve all dataset operations.
   * @summary Get Operations
   */
  const getOperationsApiV1OperationGet = (
    params?: GetOperationsApiV1OperationGetParams,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<OperationsResponse>> => {
    return axiosInstance.get(`/svc/master-data-hub/api/v1/operation/`, {
      ...options,
      params: { ...params, ...options?.params },
    });
  };

  /**
   * @summary Ds Proxy Find
   */
  const dsProxyFindApiV1DataFindPost = (
    findBody: FindBody,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DSResultsResponse>> => {
    return axiosInstance.post(
      `/svc/master-data-hub/api/v1/data/find`,
      findBody,
      options
    );
  };

  /**
   * @summary Ds Proxy Aggregate
   */
  const dsProxyAggregateApiV1DataAggregatePost = (
    aggregateBody: AggregateBody,
    params?: DsProxyAggregateApiV1DataAggregatePostParams,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DSResultsResponse>> => {
    return axiosInstance.post(
      `/svc/master-data-hub/api/v1/data/aggregate`,
      aggregateBody,
      {
        ...options,
        params: { ...params, ...options?.params },
      }
    );
  };

  /**
   * @summary Lookup
   */
  const lookupApiV2DataLookupPost = (
    lookupBody: LookupBody,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<LookupResponse>> => {
    return axiosInstance.post(
      `/svc/master-data-hub/api/v2/data/lookup`,
      lookupBody,
      options
    );
  };

  /**
   * List all datasets and their status.
   * @summary Get Datasets
   */
  const getDatasetsApiV2DatasetGet = (
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DatasetsDTO>> => {
    return axiosInstance.get(`/svc/master-data-hub/api/v2/dataset/`, options);
  };

  /**
   * Get an existing dataset by name.
   * @summary Get Single Dataset
   */
  const getSingleDatasetApiV2DatasetDatasetNameGet = (
    datasetName: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DatasetDTO>> => {
    return axiosInstance.get(
      `/svc/master-data-hub/api/v2/dataset/${datasetName}`,
      options
    );
  };

  /**
   * Retrieve a previously created dataset operation by its ID.
   * @summary Get Operation
   */
  const getOperationApiV2OperationOperationIdGet = (
    operationId: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<OperationLog>> => {
    return axiosInstance.get(
      `/svc/master-data-hub/api/v2/operation/${operationId}`,
      options
    );
  };

  /**
   * Retrieve all dataset operations.
   * @summary Get Operations
   */
  const getOperationsApiV2OperationGet = (
    params?: GetOperationsApiV2OperationGetParams,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<OperationsDTO>> => {
    return axiosInstance.get(`/svc/master-data-hub/api/v2/operation/`, {
      ...options,
      params: { ...params, ...options?.params },
    });
  };

  /**
   * @summary Get Datasets
   */
  const getDatasetsApiV2DatasetsGet = (
    params?: GetDatasetsApiV2DatasetsGetParams,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DatasetsPaginatedAPISchema>> => {
    return axiosInstance.get(`/svc/master-data-hub/api/v2/datasets`, {
      ...options,
      params: { ...params, ...options?.params },
    });
  };

  /**
   * @summary Get Dataset
   */
  const getDatasetApiV2DatasetsDatasetNameGet = (
    datasetName: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DatasetAPISchema>> => {
    return axiosInstance.get(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}`,
      options
    );
  };

  /**
   * @summary Update Dataset
   */
  const updateDatasetApiV2DatasetsDatasetNamePatch = (
    datasetName: string,
    datasetUpdateAPISchema: DatasetUpdateAPISchema,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DatasetAPISchema>> => {
    return axiosInstance.patch(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}`,
      datasetUpdateAPISchema,
      options
    );
  };

  /**
   * Create a dataset and declare its search indexes.
   *
   * The declaration reaches the registry synchronously; the enqueued reconcile
   * builds it on the engine, so the returned indexes are not queryable yet.
   * @summary Create Dataset
   */
  const createDatasetApiV2DatasetsDatasetNamePost = (
    datasetName: string,
    datasetCreateAPISchema: DatasetCreateAPISchema,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DatasetAPISchema>> => {
    return axiosInstance.post(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}`,
      datasetCreateAPISchema,
      options
    );
  };

  /**
   * Delete an existing dataset.
   *
   * **Warning**: all indexes and aliases will be lost!
   * @summary Delete Dataset
   */
  const deleteDatasetApiV2DatasetsDatasetNameDelete = (
    datasetName: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MessageResponse>> => {
    return axiosInstance.delete(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}`,
      options
    );
  };

  /**
   * Fully replace an existing dataset.
   * @summary Replace Dataset
   */
  const replaceDatasetApiV2DatasetsDatasetNameDataPut = (
    datasetName: string,
    bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut: BodyReplaceDatasetApiV2DatasetsDatasetNameDataPut,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MessageResponse>> => {
    const formData = new FormData();
    formData.append(
      `file`,
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.file
    );
    formData.append(
      `encoding`,
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.encoding
    );
    if (
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.dynamic !== undefined
    ) {
      formData.append(
        `dynamic`,
        bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.dynamic.toString()
      );
    }
    if (
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.field_delimiter !==
        undefined &&
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.field_delimiter !== null
    ) {
      formData.append(
        `field_delimiter`,
        bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.field_delimiter
      );
    }
    if (
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.escape_character !==
        undefined &&
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.escape_character !==
        null
    ) {
      formData.append(
        `escape_character`,
        bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.escape_character
      );
    }
    if (
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.quote_character !==
        undefined &&
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.quote_character !== null
    ) {
      formData.append(
        `quote_character`,
        bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.quote_character
      );
    }
    if (
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.double_quote !==
        undefined &&
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.double_quote !== null
    ) {
      formData.append(
        `double_quote`,
        bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.double_quote.toString()
      );
    }
    if (
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.field_names !==
      undefined
    ) {
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.field_names.forEach(
        value => formData.append(`field_names`, value)
      );
    }
    if (
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.ignore_first_line !==
        undefined &&
      bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.ignore_first_line !==
        null
    ) {
      formData.append(
        `ignore_first_line`,
        bodyReplaceDatasetApiV2DatasetsDatasetNameDataPut.ignore_first_line.toString()
      );
    }

    return axiosInstance.put(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}/data`,
      formData,
      options
    );
  };

  /**
   * @summary Patch Dataset Data
   */
  const patchDatasetDataApiV2DatasetsDatasetNameDataPatch = (
    datasetName: string,
    datasetDataPatchAPISchema: DatasetDataPatchAPISchema,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MessageResponse>> => {
    return axiosInstance.patch(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}/data`,
      datasetDataPatchAPISchema,
      options
    );
  };

  /**
   * Export dataset to a file.
   *
   * Rows carry MDH's internal fields (`_id`, `__digest_md5`) alongside the dataset's own columns.
   * `_id` is the row handle `PATCH /datasets/{dataset_name}/data` takes, so it is exported by
   * default; pass `exclude_internal_fields=true` when you only want the data.
   * @summary Export Dataset
   */
  const exportDatasetApiV2DatasetsDatasetNameDataGet = (
    datasetName: string,
    params?: ExportDatasetApiV2DatasetsDatasetNameDataGetParams,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<unknown>> => {
    return axiosInstance.get(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}/data`,
      {
        ...options,
        params: { ...params, ...options?.params },
      }
    );
  };

  /**
   * @summary Generate Dataset Schema
   */
  const generateDatasetSchemaApiV2DatasetsDatasetNameSchemaPost = (
    datasetName: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MessageResponse>> => {
    return axiosInstance.post(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}/_schema`,
      undefined,
      options
    );
  };

  /**
   * @summary Get Match Result
   */
  const getMatchResultApiV2MatchResultsJobIdGet = (
    jobId: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<unknown>> => {
    return axiosInstance.get(
      `/svc/master-data-hub/api/v2/match/results/${jobId}`,
      options
    );
  };

  /**
   * List the dataset's search indexes with live status.
   *
   * Declarations are diffed against the definitions last applied to the engine
   * (the changelog); drift is reported as a PENDING_* status. The engine
   * contributes index existence and build status.
   * @summary Get Search Indexes
   */
  const getSearchIndexesApiV2DatasetsDatasetNameSearchIndexesGet = (
    datasetName: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SearchIndexWithStatus[]>> => {
    return axiosInstance.get(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}/search_indexes`,
      options
    );
  };

  /**
   * Replace the dataset's declared search indexes (staging / bulk set).
   *
   * The body is the full desired list of {name, definition} entries; [] declares
   * explicitly no search indexes. The list is validated as a whole (422, nothing
   * persisted); the enqueued reconcile then drops whatever it leaves out.
   * @summary Put Search Indexes
   */
  const putSearchIndexesApiV2DatasetsDatasetNameSearchIndexesPut = (
    datasetName: string,
    searchIndexDeclarationInput: SearchIndexDeclarationInput[],
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MessageResponse>> => {
    return axiosInstance.put(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}/search_indexes`,
      searchIndexDeclarationInput,
      options
    );
  };

  /**
   * Return one search index with live status.
   *
   * 404 when the index exists neither in the registry nor in the engine.
   * @summary Get Search Index
   */
  const getSearchIndexApiV2DatasetsDatasetNameSearchIndexesIndexNameGet = (
    datasetName: string,
    indexName: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SearchIndexWithStatus>> => {
    return axiosInstance.get(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}/search_indexes/${indexName}`,
      options
    );
  };

  /**
   * Create or update one declared search index (upsert).
   *
   * The body is the writable part of the resource — the definition object; the
   * computed read fields (status, queryable, latest_definition_version) are
   * server-owned. Validated (422, nothing persisted) before it reaches the registry.
   * @summary Put Search Index
   */
  const putSearchIndexApiV2DatasetsDatasetNameSearchIndexesIndexNamePut = (
    datasetName: string,
    indexName: string,
    searchIndexDefinitionInput: SearchIndexDefinitionInput,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MessageResponse>> => {
    return axiosInstance.put(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}/search_indexes/${indexName}`,
      searchIndexDefinitionInput,
      options
    );
  };

  /**
   * Remove one declared search index from the registry.
   *
   * 404 when the dataset or the declared index does not exist. Deleting the last
   * declaration leaves [] — explicitly no search indexes, not an absent field.
   * @summary Delete Search Index
   */
  const deleteSearchIndexApiV2DatasetsDatasetNameSearchIndexesIndexNameDelete = (
    datasetName: string,
    indexName: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MessageResponse>> => {
    return axiosInstance.delete(
      `/svc/master-data-hub/api/v2/datasets/${datasetName}/search_indexes/${indexName}`,
      options
    );
  };

  /**
   * List a collection's search indexes. Superseded by the search index subresource at /v2/datasets/{dataset_name}/search_indexes.
   * @deprecated
   * @summary List Search Indexes
   */
  const listSearchIndexesApiV2CompatDataStorageSearchIndexesListPost = (
    listIndexesRequest: ListIndexesRequest,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<ListObjectsResponse>> => {
    return axiosInstance.post(
      `/svc/master-data-hub/api/v2/compat/data_storage/search_indexes/list`,
      listIndexesRequest,
      options
    );
  };

  /**
   * Create a search index on a collection. Asynchronous method. Superseded by the search index subresource at /v2/datasets/{dataset_name}/search_indexes.
   * @deprecated
   * @summary Create Search Index
   */
  const createSearchIndexApiV2CompatDataStorageSearchIndexesCreatePost = (
    createSearchIndexRequest: CreateSearchIndexRequest,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<AcceptResponse>> => {
    return axiosInstance.post(
      `/svc/master-data-hub/api/v2/compat/data_storage/search_indexes/create`,
      createSearchIndexRequest,
      options
    );
  };

  /**
   * Drop a search index on a collection. Asynchronous method. Superseded by the search index subresource at /v2/datasets/{dataset_name}/search_indexes.
   * @deprecated
   * @summary Drop Search Index
   */
  const dropSearchIndexApiV2CompatDataStorageSearchIndexesDropPost = (
    dropIndexRequest: DropIndexRequest,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<AcceptResponse>> => {
    return axiosInstance.post(
      `/svc/master-data-hub/api/v2/compat/data_storage/search_indexes/drop`,
      dropIndexRequest,
      options
    );
  };

  /**
   * Check status of an asynchronous operation. Superseded by the search index subresource at /v2/datasets/{dataset_name}/search_indexes.
   * @deprecated
   * @summary Operation Status
   */
  const operationStatusApiV2CompatDataStorageOperationStatusJobIdGet = (
    jobId: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<OperationStatusResponse>> => {
    return axiosInstance.get(
      `/svc/master-data-hub/api/v2/compat/data_storage/operation_status/${jobId}`,
      options
    );
  };

  return {
    getMetricsMetricsGet,
    healthzApiHealthzGet,
    createDatasetApiV1DatasetDatasetNamePost,
    replaceDatasetApiV1DatasetDatasetNamePut,
    updateDatasetApiV1DatasetDatasetNamePatch,
    deleteDatasetApiV1DatasetDatasetNameDelete,
    getDatasetsApiV1DatasetGet,
    matchApiV1MatchPost,
    getOperationApiV1OperationOperationIdGet,
    getOperationsApiV1OperationGet,
    dsProxyFindApiV1DataFindPost,
    dsProxyAggregateApiV1DataAggregatePost,
    lookupApiV2DataLookupPost,
    getDatasetsApiV2DatasetGet,
    getSingleDatasetApiV2DatasetDatasetNameGet,
    getOperationApiV2OperationOperationIdGet,
    getOperationsApiV2OperationGet,
    getDatasetsApiV2DatasetsGet,
    getDatasetApiV2DatasetsDatasetNameGet,
    updateDatasetApiV2DatasetsDatasetNamePatch,
    createDatasetApiV2DatasetsDatasetNamePost,
    deleteDatasetApiV2DatasetsDatasetNameDelete,
    replaceDatasetApiV2DatasetsDatasetNameDataPut,
    patchDatasetDataApiV2DatasetsDatasetNameDataPatch,
    exportDatasetApiV2DatasetsDatasetNameDataGet,
    generateDatasetSchemaApiV2DatasetsDatasetNameSchemaPost,
    getMatchResultApiV2MatchResultsJobIdGet,
    getSearchIndexesApiV2DatasetsDatasetNameSearchIndexesGet,
    putSearchIndexesApiV2DatasetsDatasetNameSearchIndexesPut,
    getSearchIndexApiV2DatasetsDatasetNameSearchIndexesIndexNameGet,
    putSearchIndexApiV2DatasetsDatasetNameSearchIndexesIndexNamePut,
    deleteSearchIndexApiV2DatasetsDatasetNameSearchIndexesIndexNameDelete,
    listSearchIndexesApiV2CompatDataStorageSearchIndexesListPost,
    createSearchIndexApiV2CompatDataStorageSearchIndexesCreatePost,
    dropSearchIndexApiV2CompatDataStorageSearchIndexesDropPost,
    operationStatusApiV2CompatDataStorageOperationStatusJobIdGet,
  };
};
export type GetMetricsMetricsGetResult = AxiosResponse<unknown>;
export type HealthzApiHealthzGetResult = AxiosResponse<HealthzResponse>;
export type CreateDatasetApiV1DatasetDatasetNamePostResult = AxiosResponse<MessageResponse>;
export type ReplaceDatasetApiV1DatasetDatasetNamePutResult = AxiosResponse<MessageResponse>;
export type UpdateDatasetApiV1DatasetDatasetNamePatchResult = AxiosResponse<MessageResponse>;
export type DeleteDatasetApiV1DatasetDatasetNameDeleteResult = AxiosResponse<MessageResponse>;
export type GetDatasetsApiV1DatasetGetResult = AxiosResponse<DatasetsResponse>;
export type MatchApiV1MatchPostResult = AxiosResponse<AnnotationContentHookResponse | void>;
export type GetOperationApiV1OperationOperationIdGetResult = AxiosResponse<DatasetOperationOut>;
export type GetOperationsApiV1OperationGetResult = AxiosResponse<OperationsResponse>;
export type DsProxyFindApiV1DataFindPostResult = AxiosResponse<DSResultsResponse>;
export type DsProxyAggregateApiV1DataAggregatePostResult = AxiosResponse<DSResultsResponse>;
export type LookupApiV2DataLookupPostResult = AxiosResponse<LookupResponse>;
export type GetDatasetsApiV2DatasetGetResult = AxiosResponse<DatasetsDTO>;
export type GetSingleDatasetApiV2DatasetDatasetNameGetResult = AxiosResponse<DatasetDTO>;
export type GetOperationApiV2OperationOperationIdGetResult = AxiosResponse<OperationLog>;
export type GetOperationsApiV2OperationGetResult = AxiosResponse<OperationsDTO>;
export type GetDatasetsApiV2DatasetsGetResult = AxiosResponse<DatasetsPaginatedAPISchema>;
export type GetDatasetApiV2DatasetsDatasetNameGetResult = AxiosResponse<DatasetAPISchema>;
export type UpdateDatasetApiV2DatasetsDatasetNamePatchResult = AxiosResponse<DatasetAPISchema>;
export type CreateDatasetApiV2DatasetsDatasetNamePostResult = AxiosResponse<DatasetAPISchema>;
export type DeleteDatasetApiV2DatasetsDatasetNameDeleteResult = AxiosResponse<MessageResponse>;
export type ReplaceDatasetApiV2DatasetsDatasetNameDataPutResult = AxiosResponse<MessageResponse>;
export type PatchDatasetDataApiV2DatasetsDatasetNameDataPatchResult = AxiosResponse<MessageResponse>;
export type ExportDatasetApiV2DatasetsDatasetNameDataGetResult = AxiosResponse<unknown>;
export type GenerateDatasetSchemaApiV2DatasetsDatasetNameSchemaPostResult = AxiosResponse<MessageResponse>;
export type GetMatchResultApiV2MatchResultsJobIdGetResult = AxiosResponse<unknown>;
export type GetSearchIndexesApiV2DatasetsDatasetNameSearchIndexesGetResult = AxiosResponse<
  SearchIndexWithStatus[]
>;
export type PutSearchIndexesApiV2DatasetsDatasetNameSearchIndexesPutResult = AxiosResponse<MessageResponse>;
export type GetSearchIndexApiV2DatasetsDatasetNameSearchIndexesIndexNameGetResult = AxiosResponse<SearchIndexWithStatus>;
export type PutSearchIndexApiV2DatasetsDatasetNameSearchIndexesIndexNamePutResult = AxiosResponse<MessageResponse>;
export type DeleteSearchIndexApiV2DatasetsDatasetNameSearchIndexesIndexNameDeleteResult = AxiosResponse<MessageResponse>;
export type ListSearchIndexesApiV2CompatDataStorageSearchIndexesListPostResult = AxiosResponse<ListObjectsResponse>;
export type CreateSearchIndexApiV2CompatDataStorageSearchIndexesCreatePostResult = AxiosResponse<AcceptResponse>;
export type DropSearchIndexApiV2CompatDataStorageSearchIndexesDropPostResult = AxiosResponse<AcceptResponse>;
export type OperationStatusApiV2CompatDataStorageOperationStatusJobIdGetResult = AxiosResponse<OperationStatusResponse>;
